/* ------ Methods ------ */
/**
 * Returns the available status constants.
 */
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const PENDING = 'PENDING';

/**
 * Returns the available statement constants.
 */
export const TRUE = 'TRUE';
export const FALSE = 'FALSE';

/**
 * Returns the available user type constants.
 */
export const userTypeMap = {
    adm: 'admin',
    stg: 'group',
    afl: 'affiliate'
} as const;

export type UserTypeKey = keyof typeof userTypeMap;
